import { FormInstance } from 'antd';
import React, { useState, useEffect, useMemo } from 'react';
import { FormQuestionMetaValue } from 'api/form/types';
import { Select } from 'components/atoms/select';
import { StarRatingConfigValues } from '../constants';
import { Values } from './form-field-configuration';

const findSelectedStarValue = (
  starOptions: {
    label: number;
    value: number;
  }[],
  selectedOption: number,
) => {
  return starOptions
    ? starOptions.find((starValue) => {
        return starValue.value === selectedOption;
      })
    : starOptions[0];
};

export const StarRatingConfigField = ({
  form,
  initialValue,
  triggerOnChange,
}: {
  form: FormInstance<Values>;
  initialValue: number;
  triggerOnChange: () => void;
}): JSX.Element => {
  const starOptions = useMemo(() => {
    return StarRatingConfigValues.map((starValue) => {
      return {
        label: starValue,
        value: starValue,
      };
    });
  }, []);

  const [selectedValue, setSelectedValue] = useState(
    findSelectedStarValue(starOptions, initialValue),
  );

  useEffect(() => {
    setSelectedValue(findSelectedStarValue(starOptions, initialValue));
  }, [starOptions, initialValue]);

  return (
    <Select
      options={starOptions || []}
      value={selectedValue}
      onChange={(v) => {
        form.setFieldsValue({
          questionMeta: {
            numberOfStar: v.value,
            type: FormQuestionMetaValue.StarRating,
          },
        });
        setSelectedValue(v);
        triggerOnChange();
      }}
    />
  );
};
